import React from 'react';
import { Route, Redirect } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Register from './components/Authentication/Register';

import UserLogin from './components/Authentication/Login';
import Callback from './components/Authentication/Callback';
import UserLogout from './components/Authentication/Logout';
import SelectTenant from './components/Authentication/SelectTenant';
import UserProfile from './components/Authentication/Profile';
import VerifyEmail from './components/Authentication/VerifyEmail';
import { getProfile, isUserLoggedIn, getTenant } from './utils/authenticated';

import NotAuthorized from './components/Authentication/NotAuthorized';
import Home from './components/Home';
import Customers from './components/Customers';
import Employees from './components/Employees';
import JobProfiles from './components/JobProfiles';
import JobProfile from './components/JobProfile';
import TaskProfiles from './components/TaskProfiles';
import TaskProfile from './components/TaskProfile';
import Jobs from './components/Jobs';
import Scheduling from './components/Scheduling';
import Admin from './components/Admin';
import Billing from './components/Billing';
import Roles from './components/Roles';
import Settings from './components/Settings';
import Printers from './components/Printers';
import Printer from './components/Printer';

import JobReport from './components/Reports/JobReport';
import ItemBreakdownReport from './components/Reports/ItemBreakdownReport';
import DetailedItemBreakdownReport from './components/Reports/DetailedItemBreakdownReport';
import Exceptions from './components/Reports/Exceptions';

import { authService } from './sagas/authentication';
import { loginRoutine, fetchUserRoutine } from './routines';

const Authenticated = (WrappedComponent) => (props) => {
  const user = getProfile();
  if (!isUserLoggedIn() || !user) {
    console.log('1');
    return <Redirect to="/login"/>;
  }
  if (!user.email_verified) {
    console.log('2');
    return <VerifyEmail/>;
  }

  return (<WrappedComponent {...props}/>);
};

const Authorized = (allowedPermissions) =>
  (WrappedComponent) => (props) => {
    const user = getProfile();
    const tenant = getTenant();

    if (!user || !tenant) {
      console.log('Authorized - no - redirecting')
      return <Redirect to="/login"/>;
    }

    const allowed = (tenant.permissions || []).find((permission) => allowedPermissions.includes(permission));

    if (allowed) {
      return (<WrappedComponent {...props} />);
    }

    return (<NotAuthorized/>);
  };

const AuthorizedUser = Authorized(['ReadOnly', 'JobCreator', 'Administrator']);
const AdminUser = Authorized(['Administrator']);

class AppView extends React.Component {
  componentWillMount() {
    console.log('appview - componentWillMount');
    authService.lock.on('authenticated', (authResult) => {
      console.log('authenticated via auth0', authResult);
      this.props.login(authResult);
      // console.log('firebaseAuth.currentUser', firebaseAuth.currentUser);
    });

    this.props.fetchUser();
  }

  render() {
    console.log('appview', this.props);
    return (<ConnectedRouter history={this.props.history}>
      <div>
        <Route path="/register" component={Register}/>

        <Route path="/login" component={UserLogin}/>
        <Route path="/callback" component={Callback}/>
        <Route path="/tenant" component={Authenticated(SelectTenant)}/>
        <Route path="/logout" component={UserLogout}/>
        {/*<Route path="/changepassword" component={ChangePassword}/>*/}
        <Route path="/verifyemail" component={VerifyEmail}/>

        <Route path="/" component={AuthorizedUser(Home)} exact/>
        <Route path="/profile" component={AuthorizedUser(UserProfile)}/>
        <Route path="/customers" component={AuthorizedUser(Customers)}/>
        <Route path="/employees" component={AuthorizedUser(Employees)}/>
        <Route path="/jobs" exact component={AuthorizedUser(Jobs)}/>
        <Route path="/taskprofile" component={AuthorizedUser(TaskProfile)}/>
        <Route path="/scheduling" component={AuthorizedUser(Scheduling)}/>
        <Route path="/reports/jobreport/:jobId" component={AuthorizedUser(JobReport)}/>
        <Route path="/reports/exceptions/:jobId" component={AuthorizedUser(Exceptions)}/>
        <Route path="/reports/itembreakdown/:jobId" component={AuthorizedUser(ItemBreakdownReport)}/>
        <Route
          path="/reports/detaileditembreakdown/:jobId"
          component={AuthorizedUser(DetailedItemBreakdownReport)}/>

        <Route path="/admin" component={AdminUser(Admin)}/>
        <Route path="/roles" component={AdminUser(Roles)}/>
        <Route path="/jobprofiles" component={AuthorizedUser(JobProfiles)}/>
        <Route path="/jobprofiles/:jobProfileId" component={AuthorizedUser(JobProfile)}/>
        <Route path="/taskprofiles" component={AuthorizedUser(TaskProfiles)}/>
        <Route path="/taskprofiles/:taskProfileId" component={AuthorizedUser(TaskProfile)}/>
        <Route path="/printers" component={AuthorizedUser(Printers)}/>
        <Route path="/printer/:printerId" component={AuthorizedUser(Printer)}/>
        <Route path="/billing" component={AdminUser(Billing)}/>
        <Route path="/settings" component={AdminUser(Settings)}/>
      </div>
    </ConnectedRouter>);
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login: loginRoutine.trigger,
    fetchUser: fetchUserRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AppView);



// WEBPACK FOOTER //
// ./src/AppView.js